/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryFilterRequest {
    getFixupPrototypeFunction() { return InventoryFilterRequest.fixupPrototype; }

    static newInstance(model: Partial<InventoryFilterRequest>): InventoryFilterRequest {
        let obj = Object.assign(new InventoryFilterRequest(), model);
        InventoryFilterRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryFilterRequest>): InventoryFilterRequest {
        if (!model) return null;
        return InventoryFilterRequest.newInstance(<InventoryFilterRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryFilterRequest) {
        if (!obj) return;

        models.InventoryFilterRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryFilterRequest): boolean {
        Object.setPrototypeOf(obj, InventoryFilterRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_account) {
            for (let val of this.cloud_account) {
                models.InventoryFilterRequestDataModel.fixupPrototype(val);
            }
        }
    }

    /**
     * Cloud accounts
     */
    cloud_account: Array<models.InventoryFilterRequestDataModel>;

}
